const IP_ADDRESS = process.env.REACT_APP_URL_BACKEND;
export const headers = [
  { field: "id", headerName: "ID", width: 24, hidden: true },
  { field: "mar_codigo", headerName: "Codigo", width: 60 },
  { field: "mar_descripcion", headerName: "Descripcion", width: 230 },
  {
    field: "mar_imagen",
    headerName: "Imagen",
    width: 300,
    renderCell: (params) => {
      const imagenUrl = params.row.mar_imagen ? `${IP_ADDRESS}${params.row.mar_imagen}` : null;
      return imagenUrl ? (
        <img
          src={imagenUrl}
          alt="imagen"
          style={{
            width: "100%",
            height: "auto",
            maxWidth: "800px",
            maxHeight: "300px",
            objectFit: "cover",
          }}
        />
      ) : (
        <div
          style={{
            width: "100%",
            height: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "14px",
            color: "#888",
          }}
        >
          Sin imagen
        </div>
      );
    },
  },
];
